import React, { useState } from 'react'
import { useHistory } from 'react-router'
import Container from '../components/layout/Container'
import Page from '../components/layout/Page'
import { BookingConfirmation } from '../components/bookingConfirmation'
import { Typography } from '../components/layout/Typography'
import { SubmitButton } from '../styles/components/buttons'
import { RouteType } from '../types/routes'
import { Footer } from '../components/layout/Footer'
import { Employee } from '../store/employees/types'
import { EmployeeAvatar } from '../styles/components/employee'
import styled from '../utils/styled'
import { Box } from '../components/layout/Box'
import { getUrlWithSalonGuid } from '../utils/urlParams'
import { GoBackButton } from '../components/layout/GoBackButton'
import { useLoadSalonData } from '../hooks/useLoadSalonData'

const BookingConfirmationPage: React.FC = () => {
  useLoadSalonData({ redirectTo: RouteType.Home })
  const { push: navigate } = useHistory()

  const [succesfullySubmitted, setSuccesfullySubmitted] = useState<boolean>(false)

  const [submittedEmployee, setSubmittedEmployee] = useState<Employee | null>(null)

  return (
    <Page>
      <Container>
        {!succesfullySubmitted && (
          <Box margin="0 0 1.5rem">
            <GoBackButton title="Datum und Uhrzeit" />
          </Box>
        )}
        {succesfullySubmitted ? (
          <Wrapper>
            <Typography variant="h3" margin="0 0 0.75rem">
              Vielen Dank!
            </Typography>
            <Typography variant="bold" margin="0 0 1.25rem">
              Termin wurde erstellt.
            </Typography>

            {submittedEmployee && (
              <>
                <EmployeeAvatar avatarSize={120} src={submittedEmployee.fotoUrl} />
                <Typography variant="body1" margin="2rem">
                  {submittedEmployee?.vorname} freut sich dich zu sehen!
                </Typography>
              </>
            )}

            <Box flex flexDirection="row" fullWidth margin="2rem">
              <SubmitButton
                onClick={() => {
                  setSubmittedEmployee(null)
                  setSuccesfullySubmitted(false)
                  navigate(getUrlWithSalonGuid(RouteType.Home))
                }}
              >
                Home
              </SubmitButton>
            </Box>
            <Footer />
          </Wrapper>
        ) : (
          <BookingConfirmation
            handleSubmit={(employee: Employee) => {
              setSubmittedEmployee(employee)
              setSuccesfullySubmitted(true)
            }}
          />
        )}
      </Container>
    </Page>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export default BookingConfirmationPage
